<template>
    <div class="card card-info">
        <div class="card-header with-border">
            <h3 class="card-title" style="width: 100%">
                Verified Prospect Students
            </h3>

        </div>
        <!-- /.box-header -->
        <!-- form start -->
        <div class="card-body">
            <div class="row">

                <div class="col-md-4">
                    Session
                    <select class="form-control" v-model="filter.SemesterID">
                        <option value="0">--Select Session--</option>
                        <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    Degree
                    <select class="form-control" v-model="filter.DegreeID" v-on:change="loadDepartment()">
                        <option value="0">--Select Degree--</option>
                        <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    Department
                    <select class="form-control" v-model="filter.DepartmentID" v-on:change="loadPrograms()">
                        <option value="0">--Select Department--</option>
                        <option v-for="item in departments" v-bind:value="item.DepartmentID">{{item.Name}}</option>
                    </select>
                </div>



                <div class="col-md-4">
                    Program
                    <select class="form-control" v-model="filter.ProgramID">
                        <option value="0">--Select Program--</option>
                        <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    Name/Form #/Father Name/CNIC
                    <input class="form-control" v-mask="'##########'" v-model="filter.Name" />
                </div>

                <div class="col-md-12">
                    <div class="form-group pull-right ">
                        <button class="btn btn-primary float-right" type="button" style="margin-top: 20px; float:right; margin-right:15px; " v-on:click="btnSearch()">Search</button>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 10px" v-if="prospects.length > 0">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped table-bordered table-color">
                            <thead class="bg-info text-white">
                                <tr>
                                    <th style="width: 5px; text-align: center">Sr.#</th>
                                    <th style="width: 20px; text-align: center">Image</th>
                                    <th style="width: 10%">Session</th>
                                    <th style="width: 20%">Program</th>
                                    <th style="width: 15%">Form #</th>
                                    <th style="width: 20%">Name</th>
                                    <th style="width: 20%">Father Name</th>
                                    <th style="width: 10%">CNIC</th>
                                    <th style="width: 5px; text-align: center;">Verified</th>
                                    <th style="width: 25px; text-align: center;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(p, ind) in prospects">
                                    <td style="text-align: center; vertical-align: middle">{{ind + 1}}</td>
                                    <td style="text-align: center; vertical-align: middle">
                                        <img style="max-height: 60px" v-bind:src="p.temp" />
                                    </td>
                                    <td style="vertical-align: middle">{{p.Session}}</td>
                                    <td style="vertical-align: middle">
                                        <span v-for="pr in p.Programs">
                                            {{pr.Priority}}. {{pr.Name}}<br />
                                        </span>
                                    </td>
                                    <td style="vertical-align: middle">{{p.FormNo}}</td>
                                    <td style="vertical-align: middle">{{p.Name}}</td>
                                    <td style="vertical-align: middle">{{p.FathersName}}</td>
                                    <td style="vertical-align: middle">{{p.CNIC}}</td>
                                    <td style="vertical-align: middle; text-align: center;">
                                        <i v-if="p.Verified == true && p.PaymentReceived == true">Yes</i>
                                        <i v-else>No</i>
                                    </td>
                                    <td style="vertical-align: middle; text-align: center;">
                                        <div class="btn-group-vertical">
                                            <!--<%--<button type="button" class="btn btn-warning" v-on:click="edit(p.ProspectStudentID)"><i class="fa fa-pencil"></i></button>--%>-->
                                            <button type="button" v-if="p.Tab >= 6" class="btn btn-info" v-on:click="printAdmissionForm(p.ProspectStudentID)" title="Print Admission From"><i class="fa fa-file"></i></button>
                                            <button type="button" v-if="p.Tab >= 6" class="btn btn-success" v-on:click="printChallanForm(p.ProspectStudentID)" title="Print Challan From"><i class="fa fa-print"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>const axios = require('axios').default;

    export default ({
        data() {
            return {
                departments: [],
                programs: [],
                semesters: [],
                degrees: [],
                filter: { SemesterID: 0, ProgramID: 0, DepartmentID: 0, DegreeID: 0, Name: '' },
                prospects: [],
            }
        },
        created: function () {
            this.pageLoad();
        },

        mounted: function () {

        },

        methods: {
            pageLoad: function () {
                var vm = this;
                startReq();

                axios.post('/api/AdmissionApi/prospectRecordPageLoad')
                    .then(function (pl) {
                        vm.semesters = pl.data.sem;
                        vm.degrees = pl.data.deg;
                        endReq();
                    })
            },

            loadDepartment() {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/loadDepartments?semID=' + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID)
                    .then(function (res) {
                        vm.departments = res.data.lst;
                        endReq();
                    })
            },

            loadPrograms() {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/loadProgramsProspect?semID=' + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID + "&depID=" + vm.filter.DepartmentID)
                    .then(function (res) {
                        vm.programs = res.data.lst;
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            edit(id) {
                var vm = this;

                startReq();
                axios.post('/admissionapi.asmx/editProspectStudent?ID=' + id)
                    .then(function (res) {
                        redirect_blank("../OnlineAdmission/DocumentVerificationForm.aspx");
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            btnSearch() {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/searchProspectStudent?type=' + 1 + "&semID=" + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID + "&depID=" + vm.filter.DepartmentID + "&progID=" + vm.filter.ProgramID + "&Name=" + vm.filter.Name, {
                    //filter: vm.filter,
                    //type: 1, // verified
                })
                    .then(function (res) {
                        vm.prospects = res.data.data;
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            printAdmissionForm(id) {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/printAdmissionForm2?ID=' + id)
                    .then(function (res) {
                        endReq();
                        window.open(res.data.url, '_blank');
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            printChallanForm(id) {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/printChallanForm?ID=' + id)
                    .then(function (res) {
                        endReq();
                        window.open(res.data.url, '_blank');
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }

    })</script>

<style>

    blink {
        -webkit-animation: 2s linear infinite condemned_blink_effect;
    }

    @-webkit-keyframes condemned_blink_effect {

        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }

    @keyframes condemned_blink_effect {
        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/onlineadmission/verifiedProspectStudents.vue